import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IDataGenericText } from '@app/interfaces/idata-grouped';


declare var $: any;
declare function dropdownInputFilter(): void;
declare function clearInputDropdown(): void;

@Component({
  selector: 'form-group-radio-multi',
  templateUrl: './form-group-radio-multi.component.html',
  styleUrls: ['./form-group-radio-multi.component.css']
})
export class FormGroupRadioMultiComponent {

  @Input() control: FormControl;
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() messageFooter: string = '';
  @Input() messageFooterAction: string = '';
  @Input() placeholderSearch: string = '';
  @Input() dataSelectLabel: Array<IDataGenericText> = [];
  @Input() enabledFilter: boolean = true;
  @Input() enabledSelectedText: boolean = true;
  @Input() style: 'purple' | 'default' = 'default';
  @Output() eventActionFooter = new EventEmitter<any>();

  public selectedText: string = '';

  constructor() { }

  ngAfterViewInit() {
    $(`#${this.id}-search`).keyup(dropdownInputFilter);
    $(`#${this.id}-dp`).on('hidden.bs.dropdown', clearInputDropdown);
    $(`#${this.id}-dp`).on('show.bs.dropdown',
      () => {
        setTimeout(() => {
          $(`#${this.id}-search`).focus()
        }, 0);
      });
  }

  onUncheckRadio(value: string) {

    if (this.control.value === value) {
      this.control.setValue('');
      this.selectedText = '';
      return;
    }

    const el = this.dataSelectLabel.find(e => `${e.id}` === `${value}`);

    this.selectedText = el ? el.text : '';

  }

  onClickActionFooter(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.eventActionFooter.next(null);
  }
}
